import { ComponentProps } from 'lib/component-props';
import TeamProfileBase from 'components/Generic/TeamProfileBase';

const TeamProfileCards = ({ fields, rendering }: ComponentProps): JSX.Element => (
  <TeamProfileBase fields={fields} rendering={rendering} showImage={false} />
);

export default TeamProfileCards;
